import { OrderCategory, SEARCH_SYMBOL_INSTRUMENT_TYPE } from '@app/_shared/providers/symbol-search/search-symbol.enums';
import { MarketKeywords, SortingTypes, WidgetViewMode } from '@app/app.structs';
import { SortingInterface } from '@app/modules/trading/modules/market-watch/structs/market-watch.interface';
import { Mastertrust, Operator, Pesb, StratX, Swastika, UtradePro } from '../../_vendors';
import { environment } from '../../environments/environment';
import { ExchangeId, StrategyStatus } from '../../utProto/enums_pb';
import { WebApiStrategyRunningType } from '../../utProto/webApiStrategyEnums_pb';
import { AlgoPermissions } from '../../utProto/webEnums_pb';

export const SOCKET_URL = 'http://10.0.0.25:10114/';
export const SERVER_URL = 'http://10.0.0.25:10114/';

export const APP_SECRET = '1';

export const ATM_RANGE = 20;

export const NEWS_API_KEY = 'ab83917857b348c3ae65ebf348610e42';

/**
 * In production mode, a placeholder will be set in place of dev environment RECAPTCHA KEY.
 */
export const RECAPTCHA_REQUIRED = true;

export const CAPTCHA_SITEKEY = (environment.production
    ? '==RECAPTCHA_PLACEHOLDER_7gQOA4UqOn=='
    : '1x00000000000000000000AA' // test Key provided by turnstile
);

export const MIXPANEL_TOKEN = 'a518613fbf6f8c648c9df0b2021ce355'; // default project id used by dev
export const BUILD_VERSION : string = (environment.production
    ? '==BUILD_VERSION_PLACEHOLDER=='
    : '' // default 
);

export const MIXPANEL_DEBUG = !environment.production;

export const ONE_MB_IN_BYTE = 1024 * 1024;
export const MAX_IMAGE_SIZE_IN_MB = 1;
export const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/svg+xml'];


export const FILE_TYPE_JSON = 'application/json';
export const FILE_SIZE = 102400; // in bytes
export const CURRENCY_SYMBOL = '\u20B9';

export const enum LOCAL_STORAGE_KEYS {
    USER_INFO = 'USER_INFO',
    OnboardingDetails = 'onboarding',
    MPIN_ENABLED = 'MPIN_ENABLED',
    TWO_FA_TOKEN = 'TWO_FA_TOKEN',
    LAST_OPENED_SYMBOL_ID = 'LAST_OPENED_SYMBOL_ID',
    UUID = 'UUID',
    ACTIVE_CHART_TYPE = 'ACTIVE_CHART_TYPE',
    COMPLETE_CHART_TYPE = 'COMPLETE_CHART_TYPE',
    ALGO_LEVEL = 'ALGO_LEVEL',
    PORTFOLIO_LEVEL = 'PORTFOLIO_LEVEL',
    SYMBOL_LEVEL = 'SYMBOL_LEVEL',
    KEYWORDS = 'keywords',
    CURRENT_TAB = 'selectedTabId',
    PAYOFF_DATA = 'PayoffData',
    IS_PRICING_SHOWN = 'IsPricingShown',
    SELECTED_PAY_OFF_INDEX = 'SelectedPayoffIndex',
    SHOW_PINNED_SYMBOLS = 'ShowPinnedSymbols',
    DELTA_VALUE = 'DeltaValue',
    POPUP_ACCEPTED = 'PopupAccepted',
    EMAIL_COMMUNICATION = 'emailCommunication',
    EMAIL_COMMUNICATION_ID = 'emailCommunicationId',
    BACKTEST_VIEW_STATUS = 'backtestViewStatus',
    POST_SI_REDIRECT_URL = 'postSiRedirectUrl',
    MASTERTRUST_ACCESS_TOKEN = 'MASTERTRUST_ACCESS_TOKEN',
    IS_NEW_FEATURE_ALERT_CLOSED = 'IS_NEW_FEATURE_ALERT_CLOSED',
    SOCIAL_LOGIN_TURNSTILE_TOKEN = 'SOCIAL_LOGIN_TURNSTILE_TOKEN',
    FREE_PLAN_EXTENDED_POPUP_ACCEPTED = 'FREE_PLAN_EXTENDED_POPUP_ACCEPTED',
    AI_DISCLAIMER_ACCEPTED = 'AI_DISCLAIMER_ACCEPTED',
    ADVISOR_THREAD_ID = 'ADVISOR_THREAD_ID',
    SHOW_SHARED_SECTION = 'SHOW_SHARED_SECTION',
    IS_FIRST_LOGIN = 'IS_FIRST_LOGIN',
    OPERATOR_TOKEN = 'OPERATOR_TOKEN',
    OPERATOR_ADMIN_TOKEN = 'OPERATOR_ADMIN_TOKEN',
    BOD_MARGIN = 'BOD_MARGIN',
    LAST_CLICKED_SYMBOL = 'LAST_CLICKED_SYMBOL',
    SELECTED_MARKET_WATCH = 'SELECTED_MARKET_WATCH',
    DEFAULT_MARKET_WATCH = 'DEFAULT_MARKET_WATCH',
    TRADING_VIEW_INTERVAL = 'TRADING_VIEW_INTERVAL',
    LAST_LOGGED_IN_USER = 'LAST_LOGGED_IN_USER',
    MANAGE_BROKERS_SELECTED_TAB = 'MANAGE_BROKERS_SELECTED_TAB',
    IS_FIXED_AI_OPENED = 'IS_FIXED_AI_OPENED',
    FROM_MOBILE = 'FROM_MOBILE',
    IS_FROM_DEPLOYED_PAGE = 'IS_FROM_DEPLOYED_PAGE'
}

export const TDL_STRINGS = [
    "com",
    "org",
    "net",
    "io",
    "co",
    "us",
    "uk",
    "de",
    "ca",
    "au",
    "tech",
    "edu",
    "gov",
    "biz",
    "info",
    "ac",
    "ad",
    "ae",
    "af",
    "ag",
    "ai",
    "al",
    "am",
    "an",
    "ao",
    "aq",
    "ar",
    "as",
    "at",
    "aw",
    "ax",
    "az",
    "ba",
    "bb",
    "bd",
    "be",
    "bf",
    "bg",
    "bh",
    "bi",
    "bj",
    "bm",
    "bn",
    "bo",
    "br",
    "bs",
    "bt",
    "bv",
    "bw",
    "by",
    "bz",
    "cc",
    "cd",
    "cf",
    "cg",
    "ch",
    "ci",
    "ck",
    "cl",
    "cm",
    "cn",
    "cr",
    "cu",
    "cv",
    "cw",
    "cx",
    "cy",
    "cz",
    "dj",
    "dk",
    "dm",
    "do",
    "dz",
    "ec",
    "in",
    "co.in",
    "net.in",
    "firm.in",
    "org.in",
    "gen.in",
    "ind.in",
    "edu.in",
    "res.in",
    "gov.in",
    "mil.in",
    "ac.in",
    "health.in",
    "tourism.in",
    "legal.in",
    "finance.in",
    "tech.in",
    "news.in",
    "entertainment.in",
    "sports.in",
    "co.uk",
    "xyz",
    "aero",
    "coop",
    "blog",
    "guru",
    "club",
    "shop",
    "travel"
]

const domainExtensionsRegex = TDL_STRINGS.join('|');

export const commonColors = {
    profit: '#43A646',
    loss: '#ed3237',
    meterBar: '#b1b1b1',
    lightThemeText: '#7e7e7e',
    darkThemeText: '#ffffff',
    darkThemeBackground: '#1d1d1d',
    lightThemeBackground: '#ffffff'
  }

  
export const REG_EX = {
    id: '^[a-zA-Z0-9]+$',
    onlyNumber: /^[a-zA-Z0-9]+$/,
    phone: /^(\+\d{1,3}[- ]?)?\d{10}$/,
    password: /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,15}$/,
    digitsOnly: '.*[0-9].*',
    notZero: /^(0*[1-9][0-9]*(\.[0-9]+)?|.\[0-9]*[1-9][0-9]*)$/,
    inProgressDecimalRegex: /^[-]?(?:\d+)?(?:\.\d*)?$/,
    strictDecimalRegex: /^[-]?(?:\d+\.\d+|\.\d+|\d+)$/,
    nonZeroNumber: /^[-+]?(?!0+$)(?!0+\.0*$)(\d+(\.\d*)?|\.\d+)$/,
    integer_only: '^[0-9]*$',
    positive_negative_integer: '^-?[0-9]*$',
    decimalAndInteger: /^([0-9]+\.?[0-9]*)$/,
    // mobile: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
    mpin: /^[0-9]{4}$/,
    // name can only contains alphabet and could not start with space
    companyName: /^\S.*$/,
    totp: /^[0-9]{6}$/,

    name: /^[a-zA-Z][a-zA-Z ].{0,100}$/,
    newName: /^(?!\.)(?!.*\.\.)(?!.*  )(?!.* \.)[A-Za-z. ]{2,50}$/,
    countryCode: /^[+][0-9]*$/,
    city: /^[a-zA-Z\s]*$/,
    state: /^[a-zA-Z()\s]*$/,
    verificationCode: /^[0-9]*$/,
    personalId: /^[a-zA-z0-9]*$/,
    // address: /^[a-zA-z0-9]*$/,
    address: /^\S.*$/,
    // tslint:disable-next-line:max-line-length

    //email regex picked from 'email-validator' library and modified to support custom TLDs
    email: `^[-!#$%&'*+/0-9=?A-Z^_a-z\`{|}~](\\.?[-!#$%&'*+/0-9=?A-Z^_a-z\`{|}~])*@[a-zA-Z0-9](-*\\.?[a-zA-Z0-9])*\\.(${domainExtensionsRegex})$`,
    newEmail: /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[A-Za-z0-9](-*\.?[A-Za-z0-9])*\.[A-Za-z]{2,}$/,

    urlRegex: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
    emptySpaces: /^(\s+\S+\s*)*(?!\s).*$/,
    spacesAtBegining: /^\S.*$/,
    soFileExtension: /^.*\.so$/,
    spaceNotAllowed: /^\S*$/,
    pan: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    gst: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,

    upi: '[a-zA-Z0-9\\.\\-]{2,256}\\@[a-zA-Z][a-zA-Z]{2,64}',
    pincode: /^\d{6}$/,
    restrictSpecialCharacter: /^[a-zA-Z0-9_ ]+$/,
    isMobileDevice: /android|iphone|kindle|ipad/i,
    datePickerFormat: /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/\d{4}$/
};

export enum CustomEvents {
    MatStepperSelectionChange = 'matStepperSelectionChange',
    StepperCompleted = 'stepperCompleted',
    OpenChart = 'openChart',
    NameChanged = 'nameChanged',
    ProfileUpdated = 'profileUpdated',
    ImageUpdated = 'imageUpdated',
    SideBarNotification = 'sideBarNotification',
    HideNotificationBadge = 'hideNotificationBadge',
    ReVerifyEmail = 'reVerifyEmail',
    PrivilegesChange = 'privileges',
    StrategyTypeChanged = 'strategyTypeChanged',
    RouteToSignup = 'RouteToSignup',
    NoUserStrategyFound = 'NoUserStrategyFound',
    StreamReconnected = 'StreamReconnected',
    PortfolioStatusEvent = 'PortfolioStatusEvent',
    EmailMobileAlreadyVerified = 'EmailMobileAlreadyVerified',
    DownloadCsv = 'DownloadCsv',
    DownloadPdf = 'DownloadPdf',
    RefreshBackTest = 'RefreshBacktest',
    PlanChanged = 'planChanged',
    PaymentResult = 'paymentResult',
    PaymentDialog = 'paymentDialog',
    PlanDialog = 'planDialog',
    DeployedTab = 'deployedTab',
    UpdatePNL = 'updatePnl',
    HDFCWindowClosed = 'HDFCWindowClosed',
    updateExitParams = 'UpdateExitParams',
    deployStrategy = 'DeployStrategy',
    fetchStrategies = 'FetchStrategies',
    changeCopyPortfolioId = 'changeCopyPortfolioId',
    BTFirstFetch = 'BTFirstFetch',
    exchangeChanged = 'exchangeChanged',
    undeployStrategyWise = 'undeployStrategyWise',
    sqaureOffStrategyWise = 'sqaureOffStrategyWise',
    TechnicalIndicatorEvents = 'TechnicalIndicatorEvents',
    StrategyIndicatorsInitialized = 'StrategyIndicatorsInitialized',  //  technical indicators in the strategy exit parameter initialized
    UpdateAiYaml = 'UpdateAiYaml',
    AiStreamReconnected = 'AiStreamReconnected',
    StrategyExchangeChange = 'StrategyExchangeChange',
    ShowAppLoader = 'ShowAppLoader',
    fundsLoaded = 'fundsLoaded',
    StrategyDetailsChanged = 'StrategyDetailsChanged',
    expiryOffsetChange = 'expiryOffsetChange',
    clientOperatorDataUpdated = 'clientOperatorDataUpdated',
    updatePositionStatus = 'updatePositionStatus',
    updatePlanStatus = 'updatePlanStatus',
    FixWithAi = 'FixWithAi',
    BookmarkPortfolioUpdated = 'BookmarkPortfolioUpdated',
    addSymbol = 'addSymbol',
    removeSymbol = 'removeSymbol',
    updateMarketWatchFeed = 'updateMarketWatchFeed',
    symbolClick = 'symbolClick',
    pinSymbol = 'pinSymbol',
    openChartInNewTab = 'openChartInNewTab',
    mwSelectEvent = 'mwSelectEvent',
    MW_SELECT_EVENT = 'MW_SELECT_EVENT',
    updatePortfolioStartTime = 'updatePortfolioStartTime',
    strategyTerminated = 'strategyTerminated',
    collapseAiEditor = 'collapseAiEditor',
    bannerClosed = 'bannerClosed',
    deployedStrategyExitConditions = 'deployedStrategyExitConditions',
    deployedPortfolioEquityPriceChange = 'deployedPortfolioEquityPriceChange',
    updateEquityPrice = 'updateEquityPrice',
    backtestUpdated = 'backtestUpdated',
    DIYUpdateAcknowledged = 'DIYUpdateAcknowledged',
    UPDATE_SCREENER_SYMBOLS_FEED = 'UPDATE_SCREENER_SYMBOLS_FEED',
    UpdateAiArtifact = 'UpdateAiArtifact',
    AiArtifactResync = 'AiArtifactResync',
    BROKER_RENAMED = 'BROKER_RENAMED',
    BROKER_DELETED = 'BROKER_DELETED',
    NEW_BROKER_CONNECTED = 'NEW_BROKER_CONNECTED',
    SwitchThread = 'SwitchThread',
    BROKER_LOGIN_SUCCESSFUL = 'BROKER_LOGIN_SUCCESSFUL',
    TAB_INDICES_UPDATED = 'TAB_INDICES_UPDATED',
    FIXED_AI_OPENED = 'FIXED_AI_OPENED',
    PlanDowngradeApplied = 'PlanDowngradeApplied',
    AdminPlanDetailOpened = 'AdminPlanDetailOpened',
    ChatPanelWidthChanged = 'ChatPanelWidthChanged',
    CreateNewConversation = 'CreateNewConversation',
    BROKER_SAVED = 'BROKER_SAVED',
    THREADS_UPDATED = 'THREADS_UPDATED',
    THREAD_TIME_UPDATE = 'THREAD_TIME_UPDATE',
    CREDITS_EXHAUSTED = 'CREDITS_EXHAUSTED',
    AI_PORTFOLIOS_UPDATED = 'AI_PORTFOLIOS_UPDATED',
    UPDATE_PORTFOLIO = 'UpdatePortfolio',
    PUBLISH_YAML = 'PublishYaml',
    OpenOptionChain = 'OpenOptionChain',
    OptionChainClosed = 'OptionChainClosed',
}

export enum CacheKeys {
    marketWatchOrder = 'MARKET_WATCH_ORDER',
    defaultMarketWatch = 'defaultMarketWatch',
    lastClickedSymbol = 'lastClickedSymbol',
    marketWatchSettings = 'MARKET_WATCH_SETTINGS'
}

export enum TechnicalIndicatorEvents {
    SymbolChanged = 'SymbolChanged',
    AllLegsRemoved = 'AllLegsRemoved',
    FirstLegAdded = 'FirstLegAdded',
    ExchangeChanged = 'ExchangeChanged',
    ResetForm = 'ResetForm'
}

export const SELECTED_VENDOR = UtradePro;

export const isSwastika =  SELECTED_VENDOR === Swastika;
export const isMastertrust = SELECTED_VENDOR === Mastertrust;
export const isPesb = SELECTED_VENDOR === Pesb;
export const isOperator = SELECTED_VENDOR === Operator;
export const isStratX = SELECTED_VENDOR === StratX;

// GMT_IST_DIFFERENCE is the time in seconds
export const GMT_IST_DIFFERENCE_SEC = 19800;

// GMT_IST_DIFFERENCE is the time in milli-seconds
export const GMT_IST_DIFFERENCE = GMT_IST_DIFFERENCE_SEC * 1000;

export const MAX_VALUE = 1e7;
export const MAX_LOT = 1e5;
export const MAX_PRICE = 1e6;
export const MIN_PRICE = 0.05;
export const MAX_QTY = 1e8;
export const MIN_QTY = 1;
export const MIN_VERSION = 1;
export const MIN_PERCENTAGE_VALUE = 0.10;
export const MIN_POINTS_VALUE = 0.01;
export const MIN_ABSOLUTE_VALUE = 1;
export const MIN_UNDERLYING_VALUE = 0.05;
export const MAX_PERCENTAGE_100 = 100;
export const MAX_PERCENTAGE = 99;
export const MAX_PERCENTAGE_LEG = 999;
export const MAX_ABSOLUTE_VALUE = 99999;
export const MAX_GLOBAL_EXIT_VALUE = 999999;
export const MIN_INDICATOR_VALUE = -999999;
export const MAX_INDICATOR_VALUE = 999999;
export const MAX_CAPITAL_VALUE = 9999999;
export const MIN_WAIT_TRADE_VALUE = -999;
export const MAX_WAIT_TRADE_VALUE = 999;
export const MIN_WAIT_TRADE_PERCENT = -100;
export const MAX_ALLOWED_DAYS = 366;
export const MAX_SAFE_INTEGER = 67108863; // 2^26 - 1

export const DEFAULT_STEP_SIZE = 1;
export const MINIMUM_MULTIPLIER = 1;
export const MAXIMUM_MULTIPLIER = 999;
export const MAXIMUM_MULTIPLIER_UNLIMITED = 99999;

export const DEFAULT_MINIMUM_MULTIPLIER = 1;
export const DEFAULT_MAXIMUM_MULTIPLIER = 10;

export const DEFAULT_TRADE_VALUE = 1;

export const MINIMUM_CANDLE_SIZE = 60
export const MAXIMUM_CANDLE_SIZE_CHARTS = 1500
export const MAXIMUM_CANDLES_REQUEST_LIMIT = 100;
export const MAX_LOT_MULTIPLIER = 30;
export const MAX_LOT_MULTIPLIER_CM = 99999;

export const MIN_MULTIPLIER_DELTA = -99999
export const MAX_LEG_MULTIPLIER_DELTA = 1
export const DELTA_TICK_SIZE = 0.01;
export const MIN_VALIDATOR_ADDITION_VALUE = 0.01;

export const GUEST_LOGIN_WITH_GOOGLE_CODE = 5;

export const MAX_DEPTH_NULL_VALUE = 2147483647;
export const MIN_DEPTH_NULL_VALUE = -2147483648;
export const DEFAULT_ITM_VALUE = 5;
export const DEFAULT_OTM_VALUE = 20;

export const MIN_SLIPPAGE_VALUE = 0;
export const MAX_SLIPPAGE_VALUE = 100;
export const SLIPPAGE_TICK_SIZE = 0.01;

// Widget state mapping that defines if the widget is minimised, All widgets are maximised by default.
export const FLUID_WIDGETS_STATE = {
    marketPicture: WidgetViewMode.DEFAULT,
    chart: WidgetViewMode.DEFAULT,
    optionChain: WidgetViewMode.DEFAULT,
};



// TODO: Temp, will be fetched
export const BROKERS =
    [{
        name: 'Share India',
        date: '26-April-2020',
        logo: '/assets/share_india.jpg'
    },
    {
        name: 'Zerodha',
        date: '26-April-2020',
        logo: '/assets/kite.png'
    },
    {
        name: 'Upstox',
        date: '29-April-2020',
        logo: '/assets/upstox.png'
    }
    ]

export const PRODUCT = ['INTRADAY', 'DELIVERY'];

export const PRICE_TYPE = ['MARKET', 'LIMIT', 'STOP LOSS MARKET', 'STOP LOSS LIMIT'];

export const PORTFOLIO_EXIT_PARAMETERS = {
    'Symbol' : 'symbol', 
    'Net Loss': 'netLoss', 
    'Net Profit': 'netProfit',
    'Premium Price': 'premiumPrice',
    'Order Lot': 'orderLot',
    'Premium Range': 'premiumRange' ,
    'Strike Diff': 'strikeDiff',
    'Stop Loss for each leg': 'stopLoss',
    'Order lot Slice': 'orderLotSlice',
    'Order Fill Price': 'orderFillPrice',
    'Strike Depth': 'strikeDepth', 
    'Time Interval(sec)': 'oiCheckTimeInterval'
}


export enum ArtifactStatus {
    Active = '• Active',
    Inactive = 'Inactive',
    Edited = '• Edited',
    Deployed = '• Deployed',
    Deleted = 'Deleted',
    Preview = '• Preview',
}

export const DEFAULT_BANNER_DETAILS = {
    message: "We are currently performing maintenance on our servers please check back later.",
    enabled: false
}


export const MOMENT_DATE_FORMAT = 'DD-MM-YYYY';
export const MOMENT_TIME_FORMAT = 'hh:mm A';
export const MOMENT_FULL_TIME_FORMAT = 'hh:mm:ss A';
export const DEFAULT_FULL_TIME_FORMAT = 'hh:mm:ss a';
export const MOMENT_COMPLETE_TIME = 'HH:mm:ss.SSS';
export const OWL_DATE_FORMAT = 'MM/DD/YYYY';
export const ECHART_DATE_FORMAT = 'YYYY-MM-DD';
export const ECHART_TOOLTIP_FORMAT = 'DD/MM/YYYY';
export const ECHART_TOOLTIP_FORMAT_SHORT = 'DD/MM/YY';
export const SHARED_ON_FORMAT = 'MMM DD, YYYY';
export const PNL_REPORT_DATE_FORMAT = 'DD_MMM_YYYY';


export const DATE_FORMAT = 'MM-dd-yyyy';
export const DATE_FORMAT_BACKTEST_TABLE = 'dd-MMM-yyyy';
export const DATE_FORMAT_BACKTEST_TABLE_DURATION = 'dd MMM yyyy';
export const DATE_FORMAT_DDMMYYY = 'dd-MM-yyyy';
export const TIME_FORMAT = 'hh:mm';
export const DATE_TIME_FORMAT = DATE_FORMAT + ' ' + TIME_FORMAT + ' aa';
export const DATE_TIME_FORMAT_BACKTEST_TABLE = DATE_FORMAT_BACKTEST_TABLE + ' ' + TIME_FORMAT + ' aa';
export const DATE_TIME_FORMAT_DDMMYYYY = DATE_FORMAT_DDMMYYY + ' ' + TIME_FORMAT + ' aa';


export const MOMENT_DATE_TIME_FORMAT = 'DDMMMyyyy hh:mm A';
export const COMPLETE_DATE_TIME_FORMAT = MOMENT_DATE_FORMAT + ' ' + MOMENT_COMPLETE_TIME;

export const OPTION_CALCULATOR_FORMAT = 'yyyyMMDDHHmmss';

export const MOMENT_MONTH_FORMAT = 'MMM';

export const EXPIRY_OFFSET_HFT_DATE_FORMAT = 'YYYYMMDD';
export const HFT_TIME_FORMAT = 'Hmmss';
export const PORTFOLIO_NAME_TIME_FORMAT = 'DDMMYY_HHmmss'

export const MOMENT_OPTION_FORMAT = 'DDMMMYY';

export const MOMENT_HOLIDAYS_FORMAT = 'YYYY-MM-DD';

export const BACKTEST_DATE_FORMAT = 'DDMMMYYYY';
export const AI_BACKTEST_DATE_FORMAT = 'DD MMM YYYY';
export const AI_PNL_TOOLTIP_FORMAT = 'dddd, Do MMM YYYY';
export const AI_PNL_MONTH_FORMAT = 'MMM YYYY';

export const BACKTEST_SYMBOL_DATE_FORMAT = 'ddMMM, yyyy';
export const TRANSACTION_DATE_FORMAT = 'DDMMM, YYYY';

export const BACKTEST_TIME_FORMAT = 'hh:mm a';

export const BOOKS_FORMAT = 'YYYYMMDD_HHMM';
export const OPTION_FORMAT = 'ddMMMyy';
export const GREEKS_REQUEST_FORMAT = 'DDMMMYY HH:mm';
export const DATE = 'DD';
export const MONTH = 'MM';
export const FULL_YEAR = 'YYYY';
export const STRATEGY_CARD_FORMAT = 'DD-MMM-YY, hh:mm A';
export const PORTFOLIO_TIME_FORMAT = TIME_FORMAT + 'A'
export const TRANSACTION_FORMAT = 'DD MMM, YYYY | hh:mm A'
export const SESSION_FORMAT = DATE + ' ' + MOMENT_MONTH_FORMAT + ', ' + FULL_YEAR;
export const UTC_TIME = 'UTC';
export const DATE_EXTEND_FORMAT = 'MMMM D, YYYY'
export const SESSION_LIMIT_FORMAT = `${OWL_DATE_FORMAT}, ${MOMENT_TIME_FORMAT}`;

// 1000 limit for in case of dev instance
export const MAXIMUM_PORTFOLIO_ALLOWED = environment.production ? 5 : 1000;

export const DEFAULT_PRECISION = 2;
// PERCENT_DIVIDER is specific to the convert number to percent. Ex 425 will be shown as 4.25%
export const PERCENT_DIVIDER = 2;
export const PRECISION_4 = 4;
export const DEFAULT_PRICE_FORMAT = '1.2-2';

// PERCENTAGE_RANGE  used to calculate 15 percent.
export const PERCENTAGE_RANGE = 0.15;
// Max Value Of Int In PostgresSQL
export const PSQL_INT_MAX = 2147483647;

export const MAX_LINEAR_SEARCH_ENTRIES = 20;

export const OPEN_ORDERS = ["PENDING", "CONFIRMED", "REPLACED", "PARTIALLY FILLED", "PENDING NEW",
    "PENDING REPLACE", "PENDING CANCEL", "SUSPENDED CONFIRMED", "SUSPENDED REPLACED", "RESTATED", "AMO PENDING"];

export const REJECTED_ORDERS = ['CANCELLED', 'NEW REJECTED', 'CANCEL REJECTED', 'REPLACE REJECTED',
    'CANCELLED IOC', 'RMS REJECT', 'PENDING CANCEL'];

export const CURRENCY_LABEL = '₹';
export const PERCENT_LABEL = '%';

export const DEFAULT_TRAILING_TICKS = 1;

export const INDEXSYMBOL = {
    NIFTY: 'NIFTY',
    BANKNIFTY: 'BANKNIFTY',
    FINNIFTY: 'FINNIFTY',
    MIDCPNIFTY: 'MIDCPNIFTY',
    SENSEX: 'SENSEX',
    BANKEX: 'BANKEX',
    ACC: 'ACC'
};

export const statusMap = {
    [StrategyStatus.STRATEGYSTATUS_RUNNING]: 0,
    [StrategyStatus.STRATEGYSTATUS_PAUSED]: 1,
    [StrategyStatus.STRATEGYSTATUS_TERMINATED]: 2
};

export const INDEX_SYMBOLS_ORDER = [INDEXSYMBOL.NIFTY, INDEXSYMBOL.BANKNIFTY, INDEXSYMBOL.FINNIFTY, INDEXSYMBOL.MIDCPNIFTY, INDEXSYMBOL.SENSEX, INDEXSYMBOL.BANKEX]

export const INDEX_SYMBOLS_NSEFO = [INDEXSYMBOL.NIFTY, INDEXSYMBOL.BANKNIFTY, INDEXSYMBOL.FINNIFTY, INDEXSYMBOL.MIDCPNIFTY]

export const INDEX_SYMBOLS_BSEFO = [INDEXSYMBOL.SENSEX, INDEXSYMBOL.BANKEX]

export const INDEX_SYMBOLS_EQUITY = [INDEXSYMBOL.ACC]

export const DEFAULT_PORTFOLIO_SYMBOL = INDEXSYMBOL.NIFTY;

export const DEFAULT_LOT_SIZE = 1;

export const DEFAULT_BUY_MARKUP_VALUE = 20;

export const DEFAULT_SELL_MARKUP_VALUE = 20;

export const DEFAULT_MARGIN_MIN_VALUE = 0;

export const OTP_LENGTH = 4;

export const MAX_SYMBOLS_IN_STRATEGY = 5;

export const NOTIFICATION_TYPES = {
    Daily: 'dailyNotifications',
    Weekly: 'weeklyNotifications',
    Monthly: 'monthlyNotifications',
    Quarterly: 'quarterlyNotifications',
    Yearly: 'yearlyNotifications'
}

export const ANGULAR_EDITOR_CONFIG = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarPosition: 'bottom',
    toolbarHiddenButtons: [
        [
            'strikeThrough',
            'subscript',
            'superscript',
            'indent',
            'outdent',
            'fontName',
            'justifyLeft',
            'justifyCenter',
            'justifyRight',
            'justifyFull',
            'redo',
            'undo'
        ],
        [
            'fontSize',
            'textColor',
            'backgroundColor',
            'customClasses',
            'insertImage',
            'insertVideo',
            'insertHorizontalRule',
            'removeFormat',
            'toggleEditorMode',
        ],
    ],
};

export const DEFAULT_MARKET_TIME = '15:30';
export const DEFAULT_START_TIME_HFT = 91500;
export const DEFAULT_END_TIME_HFT = 152000;

export const ONE_DAY_IN_MILL = 86400000;

export const MONTH_NAMES = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];

export const INDIAN_LOCALE = 'en-IN';
export const TOAST_SM_DURATION = 1100;
export const DEBOUNCE_INTERVAL = 500;
export const MARGIN_INTERVAL = 3000;
export const OPERATOR_MARGIN_INTERVAL = 5000;


export const PINNED_INDEX_SYMBOLS = [
    {
        key: '3_26000',
        pinned: true,
        value: {
            title: 'Nifty50',
            ltp: null,
            changeInPrice: null,
            changePercent: null,
            closePrice: null
        }
    },
    {
        key: '3_26009',
        pinned: true,
        value: {
            title: 'NiftyBank',
            ltp: null,
            changeInPrice: null,
            changePercent: null,
            closePrice: null
        }
    },
    {
        key: '3_26037',
        pinned: false,
        value: {
            title: 'NiftyFinService',
            ltp: null,
            changeInPrice: null,
            changePercent: null,
            closePrice: null
        }
    },
    {
        key: '3_26017',
        pinned: false,
        value: {
            title: 'IndiaVIX',
            ltp: null,
            changeInPrice: null,
            changePercent: null,
            closePrice: null
        }
    },
    {
        key: '1_1',
        pinned: false,
        value: {
            title: 'SENSEX',
            ltp: null,
            changeInPrice: null,
            changePercent: null,
            closePrice: null
        }
    },
]

export const SENSEX_SYMBOL_KEY = '1_1';

export const enum SORT_DIRECTION {
    Ascending = 'asc',
    Descending = 'desc'
}

export const CURRENT_MARKET: string[] = [MarketKeywords.NSECM, MarketKeywords.BSECM, MarketKeywords.MSECM];

export enum STRATEGY_CREATION_METHOD {
    INDICATOR_BASED,
    CPP_TYPE,
    REST_TYPE,
    PORTFOLIO,
    TVPORTFOLIO,
    YML_PORTFOLIO_CREATION,
    TV_YML_PORTFOLIO_CREATION
}

export enum PORTFOLIO_VISIBILIITY_STATUS {
    Active = 0,
    Deleted = 1
}

export enum FROM_BROKER_REDIRECT {
    DEPLOYED = 0,
    OVERVIEW = 1
}


export enum BacktestRequest {
    PORTFOLIO = 'Portfolio',
    STRATEGY = 'Strategy'
}

export enum MsgType {
    STRATEGY = 1,
    SQUAREOFF = 2
}


/**
 * indicating start of the market
 */
export const START_TIME = {
    hour: 9,
    minute: 0,
    second: 0
}


/**
 * indicating start of the day
 */
export const DAY_START_TIME = {
    hour: 5,
    minute: 30,
    second: 0
}


/**
 * indicating end of the day
 */
export const DAY_END_TIME = {
    hour: 23,
    minute: 59,
    second: 59
}

export enum TIMER_TYPE {
    STARTTIME = 0,
    SQUAREOFFTIME = 1,
    ENDTIME = 2,
    CARRYFORWARDTIME = 3,
    AUTODEPLOYMENTTIME = 4,
    AMDTIME = 5
}


export const SymbolMapSpaceSeparated = {
    "Nifty50": "Nifty 50",
    "NiftyBank": "Nifty Bank",
    "NiftyFinService": "Nifty Fin Service",
    "IndiaVIX": "India VIX"
};

export const LEGIT_PLAN_THREASHOLD = 2;

export const SNACKBAR_DURATION_LONG = 15000;

export const SNACKBAR_DURATION_MID = 10000;

export const SNACKBAR_DURATION_SHORT = 5000;

export const DELTA_REQUEST_INTERVAL = 2000;

export const MAP_ACCOUNT_LINK = 'https://rekyc.shareindia.com/forms/migration-ualgo';

export const ENABLE_FO_LINK = 'https://rekyc.shareindia.com/forms/fno';
export const THROTTLER_MAP = {
    AFFILIATE_FUNDS_BOOK: 3000,
    MARKET_WATCH_THROTTLE: 500,
    MARKET_WATCH_EVENT_THROTTLE: 100,
}

export const MAX_BT_ALLOWED_IN_MONTHS = 3;
export const MONTHLY_EXIT_DATE = Array.from({ length: 25 }, (_, i) => i);

export const WEEKLY_EXIT_DATE = Array.from({ length: 5 }, (_, i) => i);

export const EXECUTE_ON_DAYS_ARRAY = Array.from({ length: 6 }, (_, i) => i);

export const DTE_DEFAULT_VALUE = {
    less_than: 1,
    greater_than: 0
}

export const GLOBAL_EXIT_SETTINGS = '/trading/strategies/global-exit-settings';

export const LOGIN_WITH_PHONE = true;

export const FREE_PLAN_LEVEL = 1;

export const ZERO_PLAN_LEVEL = 0;

export const NO_PLAN_LEVEL = -1;

export const MASTERTRUST_TOTP_LENGTH = 6;
// In milliseconds.
export const FIREBASE_FETCH_TIMEOUT = 5000
export const MASTERTRUST_PASSWORD_MAX_LENGTH = 30;

export const WHATS_NEW_PATH = '/trading/whats-new';

export const DASHBOARD_PATH = '/trading/dashboard';
export const TRADING_PATH = '/trading/marketwatch';
export const UTRADE_ONE_AI_PATH = '/trading/utrade-intelligence';
export const OPERATOR_DASHBOARD_PATH = '/trading/operator-dashboard';
export const CREATE_CUSTOM_PATH = '/trading/strategies/create';
export const MARKET_WATCH_PATH = '/trading/marketwatch';
export const MANAGE_BROKERS_PATH = '/trading/manage-brokers';

export const UTRADE_ORIGINAL_PATH = '/trading/utrade-originals';

export const MY_STARTEGIES = '/trading/my-strategies';

export const FREQUENCY_TO_DAYS = {
    "DAILY": 1,
    "WEEKLY": 7,
    "MONTHLY": 30,
    "YEARLY": 365,
}

export const DIWALI_OFFER_DISCOUNT = {
    "Monthly": "15%",
    "Quarterly": "+ 20%",
    "Half-Yearly": "+ 25%",
    "Yearly": "+ 30%"
}

export const OFFER_DISCOUNT = {
    "Monthly": "",
    "Yearly": "20%",
    "Half-Yearly": "10%",
    "Quarterly": "5%"
}

export const CHANNELS_MAP = {
    whatsapp: 1,
    email: 2
}

export const exchangeCash = {
    [MarketKeywords.NSEFO]: MarketKeywords.NSECM,
    [MarketKeywords.BSEFO]: MarketKeywords.BSECM
}

export const NSE_INDICES = [
    AlgoPermissions.WEBALGOPERMISSION_NIFTY,
    AlgoPermissions.WEBALGOPERMISSION_MIDCAPNIFTY,
    AlgoPermissions.WEBALGOPERMISSION_FINNIFTY,
    AlgoPermissions.WEBALGOPERMISSION_BANKNIFTY,
    AlgoPermissions.WEBALGOPERMISSION_ALLNSESYMBOLS
]

export const BSE_INDICES = [
    AlgoPermissions.WEBALGOPERMISSION_ALLBSESYMBOLS,
    AlgoPermissions.WEBALGOPERMISSION_BANKEX,
    AlgoPermissions.WEBALGOPERMISSION_SENSEX
]

export const exchangesKeys = {
    [AlgoPermissions.WEBALGOPERMISSION_NSEFO]: ExchangeId.EXCHANGEID_NSEFO,
    [AlgoPermissions.WEBALGOPERMISSION_NSECM]: ExchangeId.EXCHANGEID_NSECM,
    [AlgoPermissions.WEBALGOPERMISSION_BSECM]: ExchangeId.EXCHANGEID_BSECM,
    [AlgoPermissions.WEBALGOPERMISSION_BSEFO]: ExchangeId.EXCHANGEID_BSEFO,
}
export const SUPERADMIN_LOGIN_PATH = 'auth/superadmin'
export const NEW_FEATURES_ALERT_CACHE_KEY = 'NEW_FEATURES_ALERT'
export const OPERATOR_CACHE_KEY = 'operatorCache'

export const ALLOWED_PINNED_SYMBOLS = 2;

export const MOBILE_OTP_CONFIG = {
    length: 6,
    allowNumbersOnly: true,
    inputClass: 'otp-input-custom',
    containerClass: 'otp-input-custom-container'
};

export const MULTI_BROKER_OTP_CONFIG = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    showError: true,
    inputClass: 'multi-broker-otp-input-box',
    containerClass: 'multi-broker-otp-input-container'
};

export const SWASTIKA_GENERATE_TOTP_LINK = 'https://new-justrade.swastika.co.in/';

export const SWASTIKA_GENERATE_TOTP_TUTORIAL_LINK = 'https://youtu.be/J9OY4fbaNcE';

export enum RUNNING_TYPE {
    FORWARD = 1,
    LIVE = 2,
    LIVEAUTO = 3
}

export const DEPLOY_TYPE = {
    [RUNNING_TYPE.FORWARD]: WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_PAPERTRADE,
    [RUNNING_TYPE.LIVE]: WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_LIVE,
    [RUNNING_TYPE.LIVEAUTO]: WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_LIVE,
}

export enum LearnMoreTabs {
    Overview = 0,
    StrategyDetail = 1,
    PayoffCurve = 2,
    MarginCalculator = 3
}

export const sortObj: SortingInterface[] = [{
    id: 1,
    iconText: 'A-Z',
    text: 'Alphabetically',
    state: SortingTypes.None,
    key: 'scrip_name'
},
{
    id: 2,
    iconText: 'CHG',
    text: 'Change',
    state: SortingTypes.None,
    key: 'change_in_price'
},
{
    id: 3,
    iconText: '%',
    text: 'Change in %',
    state: SortingTypes.None,
    key: 'perChange'
},
{
    id: 4,
    iconText: 'LTP',
    text: 'Last Traded Price',
    state: SortingTypes.None,
    key: 'last_trade_price'
},
{
    id: 5,
    iconText: 'EXH',
    text: 'Exchange',
    state: SortingTypes.None,
    key: 'market_id'
}];

// These colors will not change acc. to theme and there was no other efficient way to arrange these colors according to
// market_id in css file , so stored at constants.
export const SEARCH_CHIP_COLORS = {
    NSECM: ['#4DAF7C', '#FFFFFF'],
    NSEFO: ['#B2B2B2', '#1D1D1D'],
    NSECDS: ['#71D6FF', '#1D1D1D'],
    NSECOM: ['#CE5DF7', '#FFFFFF'],
    BSECM: ['#FFB9B2', '#C0392B'],
    BSEFO: ['#B2B2B2', '#1D1D1D'],
    BSECDS: ['#B8B2FF', '#484848'],
    BSECOM: ['#5DF7A4', '#484848'],
    MCX: ['#F7BC5D', '#484848'],
    NCDEX: ['#F75DBC', '#FFFFFF'],
    ESMNSE: ['#4DAF7C', '#FFFFFF'],
    MSECM: ['#4DAF7C', '#FFFFFF'],
    MSEFO: ['#F8E025', '#EF6B0B'],
    MSECD: ['#71D6FF', '#1D1D1D'],
};

export const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri'];

export const DEFAULT_AUTODEPLOYMENT_DAYS = 7;
export const DEFAULT_AUTODEPLOYMENT_START_DAY = 5;

export const MIN_CARD_SIZE_REQUIRED = 400;

export enum freePlanExtendPopType {
    Initial = 0,
    Success = 1,
    Failed = 2
}
// Default timer for LTP check, we use this to subscribe for symbols again if after this interval we don't get LTP.
// Default timer for LTP check, we use this to subscribe for symbols again if after this interval we don't get LTP.

export const SymbolSearchOrderMarket = [
    MarketKeywords.NSECM,
    MarketKeywords.BSECM,
    MarketKeywords.NSEFO,
    MarketKeywords.BSEFO,
    MarketKeywords.NSECDS,
    MarketKeywords.BSECDS,
    MarketKeywords.MCX,
    MarketKeywords.NCDEX,
    MarketKeywords.MSECM,
    MarketKeywords.MSEFO,
    MarketKeywords.MSECD,
    MarketKeywords.ESM
]

export const SymbolSearchOrderInstrumentType = [
    SEARCH_SYMBOL_INSTRUMENT_TYPE.INDEX,
    SEARCH_SYMBOL_INSTRUMENT_TYPE.COMMON_STOCK,
    SEARCH_SYMBOL_INSTRUMENT_TYPE.FUTURE,
    SEARCH_SYMBOL_INSTRUMENT_TYPE.OPTION,
]

export const SymbolSearchOrderContractType = [
    OrderCategory.single,
    OrderCategory.spread,
]
// Default timer for LTP check, we use this to subscribe for symbols again if after this interval we don't get LTP.
export const LTP_REFRESH_INTERVAL = 5000;

export const IndexWatchTutorial = 'IndexWatchTutorial';
export const IndexWatchOrder = 'IndexWatchOrder';

export const negative_cash = 'negative_cash';

export const legFormFields = ["orderMode", "instrumentType", "expiryType", "expiryOffset", "strikePriceValue", "priceCriteria", "premium" , "rangePercentageEnabled", "rangePercentageValue", "lotMultiplier", "maxDepthEnabled", "maxDepthType", "itmValue", "otmValue", "waitToTradeToggle", "waitToTradeType", "waitToTradeValue", "rangeThreshold", "reOrderConditionToggle", "thresholdTimeRange", "operatorValue", "percentOfAtmValue", "straddlePrice", "toggleEquityPrice" , "equityPrice"];

export const STRIKE_CRITERIA_FIELDS = {
    isPremiumEnabled: false,
    isRangePercentageEnabled: false,
    isMinPriceRangeEnabled: false,
    isMaxPriceRangeEnabled: false,
    isPercentOfAtmValueEnabled: false,
    isOperatorValueEnabled: false,
    isStraddlePriceEnabled: false,
  }

export const VALIDATION = {
    totp: {
        min: 16,
        max: 64
    },
    password: {
        min: 8,
        max: 12
    }
}

export const USER_LIST_PAGE_NUMBER = 1;

export const USER_LIST_PAGE_SIZE = 50;

export const DEFAULT_PAGE_SIZE = {
    page_number: 0,
    page_size: 0,
}

export const ALL_BROKER = 'ALL';

export const YAML_ERROR_FLAG = 'yaml:';

export const GOOGLE_CALLBACK_PATH = 'callback/google';

export const RETAIN_MULTIPLIER_CACHE_KEY = 'RETAIN_MULTIPLIER';

// Multi Broker Specific Constants
export const MAX_BROKER_DISPLAY_COUNT = 5;
export const DUMMY_THREAD_ID = 'dummy-thread-id';

export const CARRYFORWARD_PORTFOLIOS_POPUP_CACHE_KEY = 'last_asked_time_for_cf_portfolio_resume';

export const CARRYFORWARD_PORTFOLIOS_BROKER_WISE_CACHE_KEY = 'cf_portfolio_resume_broker_login_times';

export const PRIVACY_POLICY_URL = 'https://www.utradealgos.com/privacy-policy';
export const TERMS_CONDITIONS_URL = 'https://www.utradealgos.com/terms-and-conditions';

export const PORTFOLIO_NAME_MAX_LENGTH = 28;
export const PORTFOLIO_NAME_MAX_LENGTH_DISPLAY = 22;

export const DEFAULT_SOCKET_CONFIG = {
    max_auth_failures: 3,
    min_connected_interval_seconds: 300,
    stability_delay_seconds: 30,
    max_retry_delay_seconds: 30,
    stale_incoming_threshold_seconds: 30,
    heartbeat_interval_seconds: 10,
    mixpanel_dedupe_window_seconds: 600,
};

export const DEFAULT_BROKERS_COMING_SOON_CONFIG = {
    enabled: false,
    image_link: '/assets/images/brokers-coming-soon.png',
    login_label: 'Coming Soon',
    manage_brokers_label: 'Other Brokers Coming Soon!',
    navigation_link: ''
}

export const DEFAULT_VIRTUAL_ALGO_SPACE_CONFIG = {
    is_enabled: false,
    show_staticip_on_broker_earning_cards: false,
    show_staticip_on_broker_connection_cards: false,
    show_spacename_on_broker_earning_cards: false,
    show_spacename_on_broker_connection_cards: false,
    tooltip_text: 'Each Algo Space is a secure environment where you can map your brokers, and deploy strategies to trade live.',
    link_label: 'Learn more',
    link_url: 'https://www.utradealgos.com/algo-spaces',
};


// Allowlist of cookies preserved by Utils.clearCookies()
// Any JS-readable cookie we want to keep across app bootstraps MUST be added here,
// otherwise it will be deleted on every app load.
export const COOKIE_NAMES = {
    SESSION_EXPIRY : 'ut_session_exp',
}

// This is used to clear cookies that are not preserved by Utils.clearCookies()
export const EPOCH_EXPIRES = 'Thu, 01 Jan 1970 00:00:00 GMT';

/*VENDOR_IMAGES_START*/
export const CONFIGURABLE_IMAGES = {
    loginMainLogoUrl: 'assets/images/logos/uTrade_algos-logo.svg', // for login page header
    loginBuildStrategyWithoutCode: 'assets/icons/blue-sparkles.svg', // for login page build strategy without code
    loginBacktestBeforeYouTrade: 'assets/icons/blue-tick-shield.svg', // for login page backtest before you trade
    loginTradeAcrossMarketSegments: 'assets/icons/blue-lightning.svg', // for login page trade across market segments
    loginFreeToStart: 'assets/icons/blue-gift-box.svg', // for login page free to start
    logoUrl: 'assets/images/logos/uTrade_algos-logo.svg', // for navigation bar logo
    faviconUrl: 'assets/images/UtradePro/favicon.svg', // for favicon
    helpLogoUrl: 'assets/helpAlgoSymbol.svg',
    rightHelpArrow: 'assets/rightHelpArrow.svg',
    emptyStateDeployedIcon: 'assets/noDeployedPortfolios.png',
    emptyStatePortfoliosIcon: 'assets/noPortfoliosRunning.svg',
    emptyStateBacktestIcon: 'assets/noBacktestData.svg',
    emptyStateStrategyDetailsIcon: 'assets/strategyDetailsEmpty.svg',
    watchlistEmptyLottiePath: 'assets/lottie/watchlist_lottie.json',
    browserIcon: 'assets/icons/chrome.svg',
    appleIcon: 'assets/icons/apple.svg',
    androidIcon: 'assets/icons/android.svg',
    utradeIntelligenceLogo: 'assets/utradeIntelligence.svg',
    utradeAlgosLogoOverview: 'assets/uTradeAlgos.jpg',
    utradeAiBot: 'assets/icons/ai-sparkle.svg',
    crownIcon: 'assets/crown.svg',
    aiLogo: 'assets/icons/ai-chat-logo.svg',
    payOffCurveIcon: 'assets/icons/graph.svg',
    marginCalculatorIcon: '/assets/icons/calculator.svg',
    loaderIcon: 'assets/lottie/loader.json',
    logoutIcon: 'assets/logout.png',
};
/*VENDOR_IMAGES_END*/

/*VENDOR_DETAILS_START*/
export const CONFIGURABLE_DETAILS = {
    appName: 'uTrade Algos',
    primaryColorTradingView: '#2962FF',
}
/*VENDOR_DETAILS_END*/

export const SVGPathMap = {
    facebook: '/assets/icons/facebook.svg',
    google: '/assets/icons/google.svg',
    twitter: '/assets/icons/XIcon.svg',
    instagram: '/assets/icons/instagram.svg',
    eye: '/assets/icons/eye.svg',
    eye_off: '/assets/icons/eye-off.svg',
    notifications: '/assets/icons/notification.svg',
    search: '/assets/icons/search-normal.svg',
    percent: '/assets/images/percentage-square.svg',
    dollar: '/assets/images/dollar-square.svg',
    autoDeploy: '/assets/images/Autodeploy.svg',
    status_up: '/assets/images/status-up.svg',
    omega: '/assets/images/omega-square.svg',
    rupee: '/assets/images/rupee.svg',
    delete: '/assets/icons/delete.svg',
    info: '/assets/icons/info.svg',
    add_chain: '/assets/icons/add_chain.svg',
    whatsapp: '/assets/icons/whatsapp.svg',
    youtube: '/assets/icons/youtube.svg',
    link: '/assets/images/link.svg',
    log_in: '/assets/images/log_in.svg',
    add_icon: '/assets/icons/add_icon.svg',
    alert: '/assets/icons/alert.svg',
    browser: CONFIGURABLE_IMAGES.browserIcon,
    apple: CONFIGURABLE_IMAGES.appleIcon,
    android: CONFIGURABLE_IMAGES.androidIcon,
    inprogress: '../assets/icons/inprogress.svg',
    completed: '../assets/icons/completed.svg',
    tick: '../assets/icons/plans-tick.svg',
    cancel: '../assets/icons/plans-cancel.svg',
    create_user: '../assets/icons/create_user.svg',
    user_icon: '/assets/icons/user_icon_dark_blue.svg',
    tick_inverted: '../assets/icons/tick-inverted.svg',
    download: '../assets/icons/download_csv.svg',
    dealer_funds: '/assets/images/UtradePro/No_data_dealer.png',
    shareIndia_logo: '/assets/share_india.jpg',
    swastika_logo: '/assets/swastika-logo.svg',
    mastertrust_logo: '/assets/mastertrust-logo.svg',
    utrade_logo: '/assets/images/UtradePro/favicon.svg',
    dot_logo: '/assets/icons/dot.svg',
    share_empty_view: '/assets/images/share-table-empty.svg',
    invalid: '/assets/icons/invalid.svg',
    offer: '/assets/icons/offer.svg',
    ai_icon: '/assets/icons/ai-icon.svg',
    ai_icon_white: '/assets/icons/ai-icon-white.svg',
    chat_bot: '/assets/icons/chat-bot.svg',
    logo_extended: '/assets/images/UtradePro/uTrade.svg',
    pesb_logo: '/assets/icons/pesb.svg',
    active_session_limit_reached: '/assets/images/active-session-limit-reached.png',
    lightning: '/assets/icons/lightning.svg',
    my_profile: '/assets/icons/myProfile.svg',
    report: '/assets/icons/Report.svg',
    global_exit: '/assets/icons/globalExit.svg',
    need_help: '/assets/icons/needHelp.svg',
    create_new_account: '/assets/icons/add-user.svg',
    connect_broker: '/assets/icons/manage-broker.svg',
    refresh_margin: '/assets/refreshMargin.svg',
    setup_notification: '/assets/icons/setup_notification.svg',
    whatsapp_icon_setup: '/assets/icons/whatsapp_icon_setup.svg',
    email_icon_setup: '/assets/icons/mail_icon_setup.svg',
    edit_image: '/assets/icons/editImage.svg',
    linkedin: '/assets/icons/linkedin.svg',
    youtube_red: '/assets/icons/youtube_red.svg',
    trending_up: '/assets/icons/trending_up.svg',
    warning: '/assets/icons/warning.svg',
    error: '/assets/icons/extended-failed.svg',
    chart: '/assets/icons/chart.svg',
    sidebar: '/assets/icons/sidebar.svg',
    txn_history: '/assets/icons/txn-history.svg',
    utradeAiBot: CONFIGURABLE_IMAGES.utradeAiBot,
    utradeAiBotDisabled: '/assets/icons/ai-sparkle-greyscale.svg'
}
export const MAX_MARKET_WATCH_SYMBOLS = 50;

export const STATIC_IP_OPENERS = {
    DEPLOY_DIALOG: 'deploy_dialog',
    MANAGE_BROKERS: 'manage_brokers',
    SETUP_BROKER_DIALOG: 'setup_broker_dialog',
}